import React from "react";
import { strapiMock } from "../mocks/dashboardMock";
import FaqBox from "../components/common/faq";
import useLanguageTranslate from "../hooks/useLanguageTranslate";
import PlayStoreIcons from "../components/common/playStoreIcons";
import { LAYOUT } from "./data";
import bgImage from "../assets/images/section1bg.svg";
import { BASE_URL } from "../api/baseURL";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectDashboardWhole } from "../redux/features/dashboardSlice";
import SectionLayout from "../components/layouts/sectionLayout";
import { attachStrapiBaseUrl } from "../utils";
import listimg from "../assets/images/check_circle_outline.svg";
import section3bg from "../assets/images/section1Vector.svg";
export const Dashboard = () => {
  const dashboardDataApi = useSelector(selectDashboardWhole);
  const isLoading = dashboardDataApi.isLoading;
  const data = dashboardDataApi?.data?.data;
  const translate = useLanguageTranslate();
  console.log(data);
  return (
    <div>
      {/* Section 1 */}
      <SectionLayout
        isLoading={isLoading}
        isHide={data?.hide_hero_section}
        id={"section1"}
        className="laptop:overflow-hidden"
        logo={translate(
          attachStrapiBaseUrl(data?.hero_sec.main_logo.img?.url),
          attachStrapiBaseUrl(data?.hero_sec.main_logo.arabic_img?.url),
        )}
        title={translate(
          data?.hero_sec?.content?.title_en,
          data?.hero_sec?.content?.title_ar,
        )}
        description={translate(
          data?.hero_sec?.content?.description_en,
          data?.hero_sec?.content?.description_ar,
        )}
        playstoreBtns={
          <PlayStoreIcons
            appleLogo={translate(
              attachStrapiBaseUrl(
                data?.app_store?.img?.url,
                data?.app_store?.arabic_img?.url,
              ),
            )}
            playStoreLogo={translate(
              attachStrapiBaseUrl(
                data?.google_play?.img?.url,
                data?.google_play?.arabic_img?.url,
              ),
            )}
            className="flex gap-4 justify-center max767:justify-start"
          />
        }
        layout={LAYOUT.left}
        styles={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "cover",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <img
          src={translate(
            attachStrapiBaseUrl(data?.hero_sec.hero_image.img?.url),
            attachStrapiBaseUrl(data?.hero_sec?.hero_image?.arabic_img?.url),
          )}
          alt={translate(
            data?.hero_sec?.hero_image?.img_alt_en,
            data?.hero_sec?.hero_image?.img_alt_ar,
          )}
          className="flex w-full max-w-md mx-auto ipad:hidden max767:hidden right-0 mb-[-220px] h-[570px] laptop:absolute laptop:right-[0px] laptop:rtl:left-0 laptop:rtl:right-[unset] laptop:overflow-hidden laptop:w-[328px]"
        />
      </SectionLayout>

      {/* Section 2 */}
      <SectionLayout
        isLoading={isLoading}
        isHide={data?.hide_what_is_solidarity}
        className="selection2 "
        id={"section2"}
        title={translate(
          data?.what_is_sec?.title_en,
          data?.what_is_sec?.title_ar,
        )}
        description={translate(
          data?.what_is_sec?.description_en,
          data?.what_is_sec?.description_ar,
        )}
        layout="left"
        styles={{
          backgroundColor: "#EDFAFF",
          backgroundSize: "cover",
        }}
      >
        <img
          src={translate(
            attachStrapiBaseUrl(data?.what_is_sec?.icon?.url),
            attachStrapiBaseUrl(data?.what_is_sec?.icon_ar?.url),
          )}
          alt={data?.what_is_sec?.icon_alt_en}
          className="max767:order-first w-[425px] ipad:order-first ipad:flex-col ipad:w-[212.851px] ipad:h-[100px] ipad:mb-6 mt-[0px]  max767:mt-0 ipad:mt-0 laptop:mt-0 rtl:laptop:mt-[0] laptop:w-[324px]"
        />
      </SectionLayout>

      {/* Section 3 */}

      <SectionLayout
        isHide={data?.hide_earn_daily_section}
        id={"section3"}
        title={translate(
          data?.earn_points_sec?.content?.title_en,
          data?.earn_points_sec?.content?.title_ar,
        )}
        description={translate(
          data?.earn_points_sec?.content?.description_en,
          data?.earn_points_sec?.content?.description_ar,
        )}
        styles={{
          backgroundSize: "cover",
          backgroundImage: `url(${section3bg})`,
        }}
      >
        <div className="flex flex-col w-full">
          <div className="DailyDrivePoints grid grid-cols-6 mt-[40px] gap-6 max767:flex max767:flex-col max767:items-start max767:gap-6 max767:self-stretch">
            {data?.earn_points_sec.habits.map((point, index) => (
              <div
                key={index}
                className="points-col flex flex-col justify-center items-center gap-4 flex-[1_0_0] bg-[#F6F8F9] p-10 rounded-[26px] max767:w-full"
              >
                <img
                  src={attachStrapiBaseUrl(
                    translate(point?.icon?.url, point?.icon_ar?.url),
                  )}
                  alt={translate(point.icon_alt_en, point.icon_alt_ar)}
                  className="w-16 h-16 mx-auto mb-2"
                />
                <p className="overflow-hidden text-[#002E6D] text-center text-ellipsis text-[22px] not-italic font-medium leading-8 tracking-[-0.11px]">
                  {translate(point.title_en, point.title_ar)}
                </p>
              </div>
            ))}
          </div>
          <Link
            className="text-[#002E6D] text-lg not-italic font-medium leading-[150%] underline decoration-solid decoration-[#002E6D] text-left mt-[48px] rtl:text-right"
            to={"/terms-n-conditions"}
            // to={data?.earn_points_sec.terms_link.link}
          >
            {translate(
              data?.earn_points_sec.terms_link.label_en,
              data?.earn_points_sec.terms_link.label_ar,
            )}
          </Link>
        </div>
      </SectionLayout>

      {/* Section 4 */}

      <SectionLayout
        isHide={data?.hide_drive_safe_section}
        id={"section4"}
        title={translate(
          data?.drive_safe_sec?.content?.title_en,
          data?.drive_safe_sec?.content?.title_ar,
        )}
        description={translate(
          data?.drive_safe_sec?.content?.description_en,
          data?.drive_safe_sec?.content?.description_ar,
        )}
        styles={{
          backgroundColor: "#E8F3E8",
          backgroundSize: "cover",
        }}
      >
        <div className="flex-col w-full">
          <div className="flex items-center gap-6 self-stretch w-full ipad:flex-col ipad:mt-[48px] ipad:mb-[48px] max767:flex max767:flex-col max767:justify-center max767:items-start max767:gap-6 max767:self-stretch">
            {data?.drive_safe_sec.prizes.map((image) => (
              <div className="flex items-center gap-6 self-stretch mt-[48px] mb-[48px] ipad:w-full ipad:my-0 max767:flex max767:flex-col max767:justify-center max767:items-start max767:gap-6 max767:m-0 aspect-square w-full">
                <img
                  src={translate(
                    `${BASE_URL}${image.img?.url}`,
                    `${BASE_URL}${image.arabic_img?.url}`,
                  )}
                  alt={translate(image.alt_en, image.alt_ar)}
                  className="ipad:self-stretch ipad:w-full ipad:max-w-full ipad:object-cover h-[100%] ipad:h-[100%] ipad:mb-0 ipad:rounded-[20px] max767:object-cover max767:h-auto max767:rounded-[20px] max767:w-full "
                />
              </div>
            ))}
          </div>
          <h5 className="flex justify-start mb-4 text-[32px] text-[#002E6D]">
            {translate(
              data?.drive_safe_sec?.include_title?.title_en,
              data?.drive_safe_sec?.include_title?.title_ar,
            )}
          </h5>
          <ul className="flex flex-col items-start gap-6 self-stretch DriveSafe max767:mt-[48px]">
            {data?.drive_safe_sec.trip_details.map((trip, index) => (
              <li
                key={index}
                className="text-xl not-italic font-normal text-left flex max767:justify-start max767:items-start gap-[20px]"
              >
                <img src={listimg} className="mr-2 rtl:ml-2 rtl:mr-0" alt="" />
                <p className="text-left rtl:text-right">
                  <strong className="text-xl not-italic font-semibold text-[#002E6D]">
                    {" "}
                    {translate(trip.title_en, trip.title_ar)}{" "}
                  </strong>
                  <span className="text-xl not-italic font-normal text-[#002E6D]">
                    {" "}
                    {translate(trip.description_en, trip.description_ar)}
                  </span>
                </p>
              </li>
            ))}
          </ul>
          <p className="flex ">
            <Link
              to="/prize-rules"
              className=" text-[#002E6D] text-lg not-italic font-medium leading-[150%] underline decoration-solid decoration-[#002E6D] text-left mt-[24px] rtl:text-right"
            >
              {translate(
                data?.drive_safe_sec.prize_rules.label_en,
                data?.drive_safe_sec.prize_rules.label_ar,
              )}
            </Link>
          </p>
        </div>
      </SectionLayout>

      <SectionLayout
        isHide={data?.hide_our_responsibility}
        id={"section5"}
        title={translate(
          data?.responsibility_sec?.content?.title_en,
          data?.responsibility_sec?.content?.title_ar,
        )}
        description={translate(
          data?.responsibility_sec?.content?.description_en,
          data?.responsibility_sec?.content?.description_ar,
        )}
        bgColor={data?.responsibility_sec.bgColor}
        playstoreBtns={
          <PlayStoreIcons
            className="flex gap-4 justify-start"
            appleLogo={attachStrapiBaseUrl(
              translate(
                (data?.app_store?.img?.url, data?.app_store?.arabic_img?.url),
              ),
            )}
            playStoreLogo={attachStrapiBaseUrl(
              translate(
                (data?.google_play?.img?.url,
                data?.google_play?.arabic_img?.url),
              ),
            )}
          />
        }
        layout="left"
      >
        <div className="max767:order-1 max767:mx-auto max767:mb-[px] max767:pb-0">
          <img
            src={attachStrapiBaseUrl(
              translate(
                data?.responsibility_sec?.hero_image?.img?.url,
                data?.responsibility_sec?.hero_image?.arabic_img?.url,
              ),
            )}
            alt={translate(
              data?.responsibility_sec.hero_image.img_alt_en,
              data?.responsibility_sec.hero_image.img_alt_ar,
            )}
            className=" ipad:mx-auto  max767:pt-0 max767:pb-0 ipad:pt-[55px]"
          />
        </div>
      </SectionLayout>
      {/* Section 6 */}
      <SectionLayout
        isHide={data?.hide_better_driving}
        id={"section6"}
        title={translate(
          data?.better_driving?.content?.title_en,
          data?.better_driving?.content?.title_ar,
        )}
        description={translate(
          data?.better_driving?.content?.description_en,
          data?.better_driving?.content?.description_ar,
        )}
        styles={{
          backgroundColor: "#EDFAFF",
          backgroundSize: "cover",
        }}
      >
        <div className=" flex items-start gap-12 self-stretch grid grid-cols-3 mt-[70px] ipad:flex-col ipad:block max767:flex-col max767:flex">
          {data?.better_driving.steps.map((step, index) => (
            <div
              key={index}
              className="steps flex flex-col items-start gap-4 flex-[1_0_0] ipad:mb-[48px] max767:mb-0"
            >
              <img
                src={attachStrapiBaseUrl(
                  translate(step.icon?.url, step.icon_ar?.url),
                )}
                alt={translate(step.icon_alt_en, step.icon_alt_ar)}
                className=""
              />
              <span className="text-[#00A9E7] text-xl not-italic font-bold leading-[130%]">
                {translate(step.subtitle_en, step.subtitle_ar)}
              </span>
              <h4 className="text-[#002E6D] text-2xl not-italic font-bold leading-[130%] mb-1 text-left rtl:text-right">
                {translate(step.title_en, step.title_ar)}
              </h4>
              <p className="text-base not-italic font-normal text-[#002E6D] text-left rtl:text-right">
                {translate(step.description_en, step.description_ar)}
              </p>
            </div>
          ))}
        </div>
      </SectionLayout>

      {/* Section 7 */}
      <SectionLayout
        isHide={data?.hide_faqs}
        className="text-center"
        id={"section7"}
        title={translate(
          data?.faqs_content?.title_en,
          data?.faqs_content?.title_ar,
        )}
        description={translate(
          data?.faqs_content?.description_en,
          data?.faqs_content?.description_ar,
        )}
        playstoreBtns={
          <PlayStoreIcons
            className="flex gap-4 justify-center mx-auto"
            appleLogo={attachStrapiBaseUrl(
              translate(
                (data?.app_store?.img?.url, data?.app_store?.arabic_img?.url),
              ),
            )}
            playStoreLogo={attachStrapiBaseUrl(
              translate(
                (data?.google_play?.img?.url,
                data?.google_play?.arabic_img?.url),
              ),
            )}
          />
        }
      ></SectionLayout>

      {/* Section 8 */}
      <SectionLayout
        className="text-center section8 laptop:pt-0 ipad:pt-0"
        id={"section8"}
        title={translate(
          data?.faqs_content?.title_en,
          data?.faqs_content?.title_ar,
        )}
        description={translate(
          data?.faqs_content?.description_en,
          data?.faqs_content?.description_ar,
        )}
      >
        <div className="flex flex-col mt-[80px] w-[768px] max-w-[100%]">
          {data?.faqs.map((each) => (
            <FaqBox
              question={translate(each.question, each.question_ar)}
              answer={translate(each.answer, each.answer_ar)}
            />
          ))}
        </div>
      </SectionLayout>

      {/* Section 9*/}
      <SectionLayout
        id={"section9"}
        title={translate(
          data?.you_covered?.content?.title_en,
          data?.you_covered?.content?.title_ar,
        )}
        description={translate(
          data?.you_covered?.content?.description_en,
          data?.you_covered?.content?.description_ar,
        )}
        // bgColor={data?.section9.bgColor}
        styles={{
          backgroundColor: "#F6F8F9",
          backgroundSize: "cover",
        }}
      >
        <div className="mt-[60px] flex justify-center items-center gap-6 self-stretch ipad:flex ipad:justify-center ipad:items-center ipad:content-center ipad:gap-6 ipad:self-stretch ipad:flex-wrap max767:content-center max767:gap-6 max767:self-stretch max767:flex-wrap">
          {data?.you_covered?.cards?.map((cover, index) => (
            <a
              href={cover.link}
              key={index}
              className="justify-center flex items-center flex-col w-[168px] h-[168px] shrink-0 border bg-white shadow-[0px_0px_1px_0px_rgba(26,32,36,0.32),0px_1px_2px_0px_#5b687152] rounded-[10px] border-solid border-[#E5E9EB] hover:border-[#008dc0] hover:shadow-lg hover:cursor-pointer"
            >
              <img
                src={attachStrapiBaseUrl(
                  translate(cover?.img?.url, cover?.arabic_img?.url),
                )}
                alt={translate(cover.title_en, cover.title_ar)}
                className=" w-[70px] h-[70px] mb-3"
              />
              <h3 className="text-sm font-medium text-gray-800 hover:text-[#008dc0] hover:font-semibold">
                {translate(cover.title_en, cover.title_ar)}
              </h3>
            </a>
          ))}
        </div>
      </SectionLayout>
    </div>
  );
};
